export default __webpack_public_path__ + "static/offer-attic-aec7cfb033049b411f89bced3f879992.png";